module.exports = __webpack_public_path__ + "img/avatar2.cd9ba238.jpg";